/* tslint:disable */
/* eslint-disable */
/**
 * app
 * app
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { SetDefaultFacilityPhysician200ResponseDataPhysicianId } from './SetDefaultFacilityPhysician200ResponseDataPhysicianId';
import {
    SetDefaultFacilityPhysician200ResponseDataPhysicianIdFromJSON,
    SetDefaultFacilityPhysician200ResponseDataPhysicianIdFromJSONTyped,
    SetDefaultFacilityPhysician200ResponseDataPhysicianIdToJSON,
} from './SetDefaultFacilityPhysician200ResponseDataPhysicianId';

/**
 * 
 * @export
 * @interface SetDefaultFacilityPhysician200ResponseData
 */
export interface SetDefaultFacilityPhysician200ResponseData {
    /**
     * 
     * @type {SetDefaultFacilityPhysician200ResponseDataPhysicianId}
     * @memberof SetDefaultFacilityPhysician200ResponseData
     */
    physician_id?: SetDefaultFacilityPhysician200ResponseDataPhysicianId | null;
}

/**
 * Check if a given object implements the SetDefaultFacilityPhysician200ResponseData interface.
 */
export function instanceOfSetDefaultFacilityPhysician200ResponseData(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SetDefaultFacilityPhysician200ResponseDataFromJSON(json: any): SetDefaultFacilityPhysician200ResponseData {
    return SetDefaultFacilityPhysician200ResponseDataFromJSONTyped(json, false);
}

export function SetDefaultFacilityPhysician200ResponseDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): SetDefaultFacilityPhysician200ResponseData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'physician_id': !exists(json, 'physician_id') ? undefined : SetDefaultFacilityPhysician200ResponseDataPhysicianIdFromJSON(json['physician_id']),
    };
}

export function SetDefaultFacilityPhysician200ResponseDataToJSON(value?: SetDefaultFacilityPhysician200ResponseData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'physician_id': SetDefaultFacilityPhysician200ResponseDataPhysicianIdToJSON(value.physician_id),
    };
}

